import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const HeatRecoveryForm = ({ unit, onChange }) => {
  const [showAdvanced, setShowAdvanced] = useState(unit.advancedEnabled || false);

  const handleChange = (key, value) => {
    const updated = {
      ...unit,
      [key]: value,
    };

    if (unit.type === 'hru') {
      updated.type = 'hru';
    }

    onChange(updated);
  };

  const getUnitCode = (id) => `IGK-${id.toString().padStart(2, '0')}`;

const renderImage = () => {
  const device = unit.deviceType?.toLowerCase();
  const filter = unit.filtration || 'kaba'; // varsayılan kaba
  const heating = unit.heatingNeed || 'hayir';
  const cooling = unit.coolingNeed || 'hayir';

  if (!device) {
    return (
      <div style={{ textAlign: 'center', color: '#888', paddingTop: 50 }}>
        Cihaz Tipi Seçilmedi
      </div>
    );
  }

  // 🔧 STANDART
  if (device === 'standart') {
    const img = filter === 'ince' ? 'hru_G4_F7.png' : 'hru_G4.png';
    return (
      <img
        src={`/images/hru/${img}`}
        alt={`Standart - ${img}`}
        style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }}
      />
    );
  }

  // 🔧 BATARYALI
  if (device === 'bataryalı') {
    let imageName = '';

    if (heating === 'evet' && cooling === 'evet') {
      imageName = `hru_isi_sog_${filter === 'ince' ? 'G4_F7' : 'G4'}.png`;
    } else if (heating === 'evet') {
      imageName = `hru_isi_${filter === 'ince' ? 'G4_F7' : 'G4'}.png`;
    } else if (cooling === 'evet') {
      imageName = `hru_sog_${filter === 'ince' ? 'G4_F7' : 'G4'}.png`;
    } else {
      imageName = `hru_${filter === 'ince' ? 'G4_F7' : 'G4'}.png`;
    }

    return (
      <img
        src={`/images/hru/${imageName}`}
        alt={`Bataryalı - ${imageName}`}
        style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }}
      />
    );
  }

  // 🔧 KOMPRESÖRLÜ (şimdilik sabit)
  // 🔧 KOMPRESÖRLÜ
if (device === 'kompresörlü') {
  const imageName = filter === 'ince' ? 'hru_comp_G4_F7.png' : 'hru_comp_G4.png';
  return (
    <img
      src={`/images/hru/${imageName}`}
      alt={`Kompresörlü - ${imageName}`}
      style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }}
    />
  );
}
};

  return (
    <div
      style={{
        border: '1px solid #ccc',
        borderRadius: 8,
        padding: 20,
        marginBottom: 30,
        backgroundColor: '#f9f9f9',
      }}
    >
      <h3 style={{ marginBottom: 10 }}>
        {getUnitCode(unit.id)} - Isı Geri Kazanım Cihazı
      </h3>

      <div className="form-row">
        <label>Cihaz Tipi:</label>
       <select
  value={unit.deviceType || ''}
  onChange={(e) => handleChange('deviceType', e.target.value)}
  style={{
    backgroundColor: '#fff',
    border: '1px solid #ccc',
    borderRadius: 6,
    padding: '8px 10px',
    fontSize: '16px',
    height: 38,
    lineHeight: '1.2',
    width: '250px',
    marginBottom: 10,
    boxSizing: 'border-box',
  }}
>

          <option value="">Seçiniz</option>
          <option value="standart">Standart</option>
          <option value="bataryalı">Bataryalı</option>
          <option value="kompresörlü">Kompresörlü</option>
        </select>
      </div>

      <div
        style={{
          marginTop: 10,
          marginBottom: 25,
          height: 300,
          backgroundColor: '#fff',
          border: '1px solid #ddd',
          borderRadius: 6,
          padding: 10,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        {renderImage()}
      </div>

     <div style={{ display: 'flex', gap: 10, marginBottom: 20 }}>
  <div className="form-row" style={{ flex: 1 }}>
    <label>Hava Debisi (m³/h):</label>
    <input
      type="number"
      value={unit.airflow || ''}
      onChange={(e) => handleChange('airflow', e.target.value)}
    />
  </div>
  <div className="form-row" style={{ flex: 1 }}>
    <label>Basınç Kaybı (Pa):</label>
    <input
      type="number"
      value={unit.pressureLoss || ''}
      onChange={(e) => handleChange('pressureLoss', e.target.value)}
    />
  </div>
</div>

<div className="form-row" style={{ marginBottom: 20 }}>
  <label>Elektrikli Isıtıcı:</label>
  <select
    value={unit.electricHeater || ''}
    onChange={(e) => handleChange('electricHeater', e.target.value)}
  >
    <option value="">Seçiniz</option>
    {[...Array(20)].map((_, i) => {
      const kw = i + 1;
      return (
        <option key={kw} value={`${kw} kW`}>{`${kw} kW`}</option>
      );
    })}
  </select>
</div>

      {/* ISITMA İHTİYACI */}
      <AnimatePresence>
  {['bataryalı', 'kompresörlü'].includes(unit.deviceType?.toLowerCase()) && (
    <motion.div
      key="heating"
      initial={{ opacity: 0, height: 0 }}
      animate={{ opacity: 1, height: 'auto' }}
      exit={{ opacity: 0, height: 0 }}
      transition={{ duration: 0.3 }}
      className="form-row"
    >
      <label>Isıtma İhtiyacı:</label>
      <select
        value={unit.heatingNeed || ''}
        onChange={(e) => handleChange('heatingNeed', e.target.value)}
      >
        <option value="">Seçiniz</option>
        <option value="evet">Evet</option>
        <option value="hayir">Hayır</option>
      </select>
    </motion.div>
  )}
</AnimatePresence>


      {unit.heatingNeed === 'evet' && (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 15, marginTop: 10 }}>
          <div>
            <label>Isıtma Yöntemi:</label>
            <select
              value={unit.heatingType || ''}
              onChange={(e) => handleChange('heatingType', e.target.value)}
            >
              <option value="">Seçiniz</option>
              <option value="Sıcak Sulu 80-60">Sıcak Sulu 80-60</option>
              <option value="Sıcak Sulu 90-70">Sıcak Sulu 90-70</option>
              <option value="DX">DX</option>
              <option value="Diğer">Diğer</option>
            </select>
          </div>

          <div>
            <label>Isıtma Kapasitesi (kW):</label>
            <input
              type="number"
              value={unit.heatingCapacity || ''}
              onChange={(e) => handleChange('heatingCapacity', e.target.value)}
            />
          </div>

          <div style={{ alignSelf: 'center', fontStyle: 'italic' }}>— ve/veya —</div>

          <div>
            <label>Isıtma Üfleme Sıcaklığı (°C):</label>
            <input
              type="number"
              value={unit.heatingBlowTemp || ''}
              onChange={(e) => handleChange('heatingBlowTemp', e.target.value)}
            />
          </div>
        </div>
      )}

      {/* SOĞUTMA İHTİYACI */}
      <AnimatePresence>
  {['bataryalı', 'kompresörlü'].includes(unit.deviceType?.toLowerCase()) && (
    <motion.div
      key="cooling"
      initial={{ opacity: 0, height: 0 }}
      animate={{ opacity: 1, height: 'auto' }}
      exit={{ opacity: 0, height: 0 }}
      transition={{ duration: 0.3 }}
      className="form-row"
      style={{ marginTop: 20 }}
    >
      <label>Soğutma İhtiyacı:</label>
      <select
        value={unit.coolingNeed || ''}
        onChange={(e) => handleChange('coolingNeed', e.target.value)}
      >
        <option value="">Seçiniz</option>
        <option value="evet">Evet</option>
        <option value="hayir">Hayır</option>
      </select>
    </motion.div>
  )}
</AnimatePresence>

      {unit.coolingNeed === 'evet' && (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 15, marginTop: 10 }}>
          <div>
            <label>Soğutma Yöntemi:</label>
            <select
              value={unit.coolingType || ''}
              onChange={(e) => handleChange('coolingType', e.target.value)}
            >
              <option value="">Seçiniz</option>
              <option value="Soğuk Sulu 7-12">Soğuk Sulu 7-12</option>
              <option value="DX">DX</option>
              <option value="Diğer">Diğer</option>
            </select>
          </div>

          <div>
            <label>Soğutma Kapasitesi (kW):</label>
            <input
              type="number"
              value={unit.coolingCapacity || ''}
              onChange={(e) => handleChange('coolingCapacity', e.target.value)}
            />
          </div>

          <div style={{ alignSelf: 'center', fontStyle: 'italic' }}>— ve/veya —</div>

          <div>
            <label>Soğutma Üfleme Sıcaklığı (°C):</label>
            <input
              type="number"
              value={unit.coolingBlowTemp || ''}
              onChange={(e) => handleChange('coolingBlowTemp', e.target.value)}
            />
          </div>
        </div>
      )}

      {/* GELİŞMİŞ AYARLAR */}
      <div style={{ marginTop: 20 }}>
        <button
          onClick={() => {
            setShowAdvanced(!showAdvanced);
            handleChange('advancedEnabled', !showAdvanced);
          }}
          className="btn-small"
          style={{ padding: '6px 12px', fontSize: 13 }}
        >
          {showAdvanced ? 'Gelişmiş Ayarları Gizle' : 'Gelişmiş Ayarları Göster'}
        </button>
      </div>

      <AnimatePresence>
        {showAdvanced && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            exit={{ opacity: 0, height: 0 }}
            style={{
              overflow: 'hidden',
              marginTop: 15,
              padding: 15,
              border: '1px dashed #ccc',
              borderRadius: 8,
              backgroundColor: '#fff',
            }}
          >
            <div className="form-row" style={{ marginBottom: 15 }}>
  <label>Filtrasyon:</label>
  <select
    value={unit.filtration || 'kaba'}
    onChange={(e) => handleChange('filtration', e.target.value)}
  >
    <option value="kaba">Kaba 'G4'</option>
    <option value="ince">İnce 'G4 F7'</option>
  </select>
</div>

            <div className="form-row">
  <label>Isı Geri Kazanım Verimi (%):</label>
  <input
    type="number"
    min="0"
    max="99"
    value={unit.efficiency || ''}
    onChange={(e) => {
      const val = parseInt(e.target.value);
      if (!isNaN(val) && val >= 0 && val <= 99) {
        handleChange('efficiency', val);
      } else if (e.target.value === '') {
        handleChange('efficiency', '');
      }
    }}
  />
</div>

            <div className="form-row">
  <label>Ön Elektrikli Isıtıcı:</label>
  <select
    value={unit.preElectricHeater || ''}
    onChange={(e) => handleChange('preElectricHeater', e.target.value)}
  >
    <option value="">Seçiniz</option>
    {[...Array(20)].map((_, i) => {
      const kw = i + 1;
      return (
        <option key={kw} value={`${kw} kW`}>{`${kw} kW`}</option>
      );
    })}
  </select>
</div>

          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default HeatRecoveryForm;
